import { QueryClientProvider } from '@tanstack/react-query';
import { createQueryClient } from './api/query-client';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router';
import { watchSystemTheme } from './lib/theme';
import { routes } from './router';
import './styles.css';

const queryClient = createQueryClient({ queries: { refetchOnWindowFocus: false } });
const router = createBrowserRouter(routes);

watchSystemTheme();

const root = document.getElementById('root');
if (root) {
  createRoot(root).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </StrictMode>,
  );
}
